<template>
  <div>
  <el-card style="margin-top: 15px" class="echarts">
    <v-chart :options="product_summary" :autoresize="true" />
  </el-card>
  <br/>
  <el-card style="margin-top: 15px">
    <v-chart :options="pm_summary" :autoresize="true" />
  </el-card>
  <br/>
  <el-card style="margin-top: 15px">
    <v-chart :options="due_date_summary" :autoresize="true" />
  </el-card>
  </div>

</template>

<script>
import projectApi from "@/api/project";

export default {
  name: "projectSummary",
  data() {
    return {
      product_summary: {
        title: [
          {
            text: 'Products/Projects'
          }
        ],
        tooltip: {},
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
        },
        axisTick: {
          show: false
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      },
      pm_summary:{
        title: [
          {
            text: 'PM/Projects'
          }
        ],
        tooltip: {},
        legend: {
          data: ["To Do","In Progress","Hold","Complete"],
        },
        xAxis: {
          data: [],
        },
        yAxis: {
          minInterval:1
        },
        series: [
        ],
      },
      due_date_summary:{
        title: [
          {
            text: 'Due Date/Projects'
          }
        ],
        tooltip: {},
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value',
          minInterval:1
        },
        axisTick: {
          show: false
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            }
          }
        ]
      }
    };
  },
  methods: {
    getPms(){
      projectApi.getPmSummary().then(
        res => {
          this.pm_summary.xAxis.data = res.data['pms']
          this.pm_summary.series = res.data['series']
        }
      )
    },
    getProducts(){
      projectApi.getProductSummary().then(
        res => {
          this.product_summary.xAxis.data = res.data['products']
          this.product_summary.series[0].data = res.data['data']
        }
      )
    },
    getDueDates(){
      projectApi.getDueDateSummary().then(
        res => {
          this.due_date_summary.xAxis.data = res.data['dates']
          this.due_date_summary.series[0].data = res.data['counts']
        }
      )
    }

  },
  mounted(){
    this.getProducts()
    this.getPms()
    this.getDueDates()
  },
};

</script>

<style scoped>
.echarts {
  margin: 0 auto;
  width:100%;
}
</style>
